/*
  Alpha Zen redesign: the testimonial marquee.

  The mockup renders every quote twice, the second set aria-hidden, and sets
  `will-change: transform` on the track: a continuous left drift that wraps once
  it has travelled the width of one set, so the seam never shows. Pauses on
  hover and on focus inside the track, and does not run at all when the visitor
  asks for reduced motion.
*/
(function () {
  const SPEED = 40; // px per second

  function init(root) {
    (root || document).querySelectorAll('[data-az-marquee]').forEach(function (marquee) {
      if (marquee.dataset.azReady === 'true') return;
      marquee.dataset.azReady = 'true';

      const track = marquee.querySelector('.mtrack');
      if (!track) return;

      /*
        Reduced motion: never drift. The second, aria-hidden set of quotes only
        exists to hide the loop seam, so once the loop is off it is dead weight
        that keeps the track overflowing and leaves the row clipped mid-sentence
        at both edges — which reads as broken rather than as a deliberate still
        state. Mark the marquee and let az-site.css drop the duplicate set and
        wrap the real quotes into a tidy grid inside the measure.
      */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        marquee.dataset.azStill = 'true';
        return;
      }

      let offset = 0;
      let last = null;
      let paused = false;

      marquee.addEventListener('mouseenter', function () {
        paused = true;
      });
      marquee.addEventListener('mouseleave', function () {
        paused = false;
      });
      marquee.addEventListener('focusin', function () {
        paused = true;
      });
      marquee.addEventListener('focusout', function () {
        paused = false;
      });

      function step(now) {
        if (last === null) last = now;
        const delta = (now - last) / 1000;
        last = now;

        const span = track.scrollWidth / 2;
        if (!paused && span > 0) {
          offset += SPEED * delta;
          if (offset >= span) offset -= span;
          track.style.transform = 'translateX(' + -offset + 'px)';
        }

        window.requestAnimationFrame(step);
      }

      window.requestAnimationFrame(step);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
